export class MoneyOut {  
    public transaction_date: string|undefined;
    public expense_type: any|undefined;
    public amount: number|undefined;
    public payment_method_id: number|undefined;
    public transaction_date_formatted: string|undefined;
}